module.exports = "/_next/static/images/ucl-header-atelier-text-b41ee789f152fb3a5fc39ebac07f6ff1.png";